export default "/_next/static/assets/MuseoSansCondensed-700_c8425aab2633851a363ea89ddbadf8d3.woff2";